<template>
  <div class="liveTask" @click="toDetail">
    <div class="imgBox">
      <img v-lazy="detail.cover" alt="">
    </div>
    <dl class="info">
      <dt>{{ detail.name }}</dt>
      <dd class="teacher text-overflow">
        <span v-show="detail.lecturerName">主讲老师：{{ detail.lecturerName }}</span>
      </dd>
      <dd class="box">
        <div class="time"><span class="icon-clock-bg"></span><span>{{ detail.startedDate }}</span></div>
        <div class="status">
          <div class="play" v-if="detail.status === 'ON_THE_AIR'">
            <ul class="playing"><li></li><li></li><li></li></ul>
            <span class="themeColor">直播中</span>
          </div>
          <span v-else-if="detail.status === 'NOT_STARTED'">未开始</span>
          <span v-else>直播已结束</span>
        </div>
      </dd>
    </dl>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { appPort } from '@/widget/index'
import app from '@/widget/app'
const props = defineProps({
  detail: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
const toDetail = () => {
  if (appPort()) {
    app.postMessage({
      type: 'live_stream_detail',
      id: props.detail.liveId
    })
  }
}
</script>

<style lang="scss" scoped>
@keyframes upDown {
  0% {
    height: 24px;
    margin-top: 0;
  }
  50% {
    margin-top: 12px;
    height: 12px;
  }
  100% {
    height: 24px;
    margin-top: 0;
  }
}
@keyframes downUp {
  0% {
    height: 12px;
    margin-top: 12px;
  }
  50% {
    margin-top: 0;
    height: 24px;
  }
  100% {
    height: 12px;
    margin-top: 12px;
  }
}
.liveTask {
  display: flex;
  align-items: center;
  width: 289 * 2px;
  justify-content: space-between;
  .imgBox {
    width: 216px;
    height: 180px;
    border-radius: 12px;
    overflow: hidden;
    background: $grayF;
  }
  .info {
    width: 340px;
    font-size: 24px;
    color: $gray9;
    dt {
      height: 80px;
      line-height: 40px;
      @include multi-ellipsis(2);
      margin-bottom: 4px;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      color: $black;
    }
    .teacher {
      height: 34px;
      margin-bottom: 22px;
    }
    .box {
      display: flex;
      justify-content: space-between;
      .time {
        display: flex;
        align-items: center;
      }
    }
    .status {
      width: 136px;
      height: 48px;
      background: #F5F5F7;
      border-radius: 31px;
      text-align: center;
      line-height: 48px;
      overflow: hidden;
      .play {
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .playing {
        height: 24px;
        width: 24px;
        display: flex;
        justify-content: space-between;
        align-items: bottom;
        margin-right: 5px;
        overflow: hidden;
        li {
          height: 24px;
          width: 3px;
          background: $themeColor;
          border-radius: 3px;
        }
        li:first-child, li:last-child {
          animation: upDown 600ms linear infinite;
        }
        li:first-child + li {
          animation: downUp 600ms linear infinite;
        }
      }
    }
  }
}
</style>
